module.exports = __webpack_public_path__ + "img/1.a0a9b010.png";